<div class="grid">
    <div class="col-12">
        <div class="card" *ngIf="!permissaoInserir">
            <div style="text-align: center">
                <h4>Você não possui permissão de acesso essa página!</h4>
            </div>
        </div>
        <div class="card" *ngIf="permissaoInserir">
            <form #f="ngForm" name="form" novalidate>
                <div class="formgroup">
                    <div class="p-fluid p-formgrid grid">
                        <div *ngIf="messagemVisivel" class="field col-12 md:col-12">
                            <p-messages
                                [(value)]="messages"
                                [enableService]="false"
                                [closable]="true"
                            ></p-messages>
                        </div>
                        <div class="field col-12 md:col-3">
                            <label htmlFor="cpf">CPF</label>
                            <div class="flex">
                                <p-inputMask
                                    class="w-full"
                                    mask="999.999.999-99"
                                    [unmask]="true"
                                    type="text"
                                    placeholder="000.000.000-00"
                                    name="cpf"
                                    ngModel
                                    #cpf="ngModel"
                                    (onBlur)="buscarUsuario(cpf.value)"
                                    [(ngModel)]="cpfInformado"
                                    [disabled]="desabilitaCampoCpf"
                                ></p-inputMask>
                                <button
                                    type="button"
                                    class="p-button-primary ml-2 w-4rem"
                                    pButton
                                    pRipple
                                    [pTooltip]="desabilitaCampoCpf ? 'Desbloquear' : 'Bloquear'"
                                    [icon]="desabilitaCampoCpf ? 'pi pi-lock' : 'pi pi-lock-open'"
                                    (click)="liberarCampoCpf()"
                                ></button>
                            </div>
                        </div>
                        <div class="field col-12 md:col-6">
                            <label htmlFor="nome">Nome Completo</label>
                            <label class="form-control">{{ usuario.nome }}</label>
                        </div>
                        <div class="field col-12 md:col-3">
                            <label htmlFor="apelido">Apelido</label>
                            <input
                                oninput="this.value = this.value.toUpperCase();"
                                name="apelido"
                                type="text"
                                pInputText
                                ngModel
                                #apelido="ngModel"
                                [(ngModel)]="profissional.nomeProfissional"
                            />
                        </div>
                        <div class="field col-12 md:col-2">
                            <label htmlFor="funcao">Função</label>
                            <input
                                oninput="this.value = this.value.toUpperCase();"
                                name="funcao"
                                type="text"
                                pInputText
                                ngModel
                                #funcao="ngModel"
                                required
                                [(ngModel)]="profissional.funcao"
                            />
                            <div
                                *ngIf="funcao.hasError('required') && funcao.touched"
                                class="alerta"
                            >
                                <small>Campo obrigatório</small>
                            </div>
                        </div>

                        <div class="field col-12 md:col-2">
                            <label htmlFor="telefone">Fone Profissional</label>
                            <p-inputMask
                                mask="(99) 99999-9999"
                                [unmask]="true"
                                type="text"
                                placeholder="(99) 99999-9999"
                                name="telefone"
                                ngModel
                                #telefone="ngModel"
                                [(ngModel)]="profissional.telefone"
                            ></p-inputMask>
                        </div>
                        <div class="field col-12 md:col-3">
                            <label htmlFor="tipo">Tipo</label>
                            <p-dropdown
                                [options]="tipos"
                                [filter]="true"
                                optionLabel="label"
                                optionValue="value"
                                emptyFilterMessage="Nenhum registro"
                                name="tipo"
                                ngModel
                                #tipo="ngModel"
                                (onChange)="selecionaTipo(tipo.value)"
                                [(ngModel)]="profissional.tipo"
                            ></p-dropdown>
                        </div>

                        <div class="field col-12 md:col-3" *ngIf="tipo.value == 'COLABORADOR'">
                            <label for="contrato">Contrato</label>
                            <p-dropdown
                                [options]="contratos"
                                optionLabel="razaoSocial"
                                name="contrato"
                                ngModel
                                #contrato="ngModel"
                                [(ngModel)]="profissional.contrato"
                            ></p-dropdown>
                        </div>
                        <div class="field col-12 md:col-3" *ngIf="tipo.value == 'PARCEIRO'">
                            <label for="contrato">Contrato</label>
                            <div class="flex flex-column md:flex-row">
                                <p-dropdown
                                    [options]="contratos"
                                    optionLabel="razaoSocial"
                                    name="contrato"
                                    ngModel
                                    #contrato="ngModel"
                                    style="width: 80% !important"
                                    emptyMessage="Nenhum registro encontrado"
                                    [(ngModel)]="profissional.contrato"
                                ></p-dropdown>
                                <button
                                    *ngIf="contratos.length < 1"
                                    type="button"
                                    pButton
                                    class="p-button-success ml-2"
                                    icon="pi pi-plus"
                                    style="width: 20% !important"
                                    pTooltip="Cadastrar Novo Contrato"
                                    (click)="abrirModalContrato()"
                                ></button>
                            </div>
                        </div>
                        <div class="field col-12 md:col-1">
                            <label for="agenda">Agenda?</label>
                            <br />
                            <p-inputSwitch
                                name="agenda"
                                ngModel
                                #agenda="ngModel"
                                [(ngModel)]="profissional.agenda"
                            ></p-inputSwitch>
                        </div>
                    </div>

                    <div class="p-fluid p-formgrid grid justify-content-between">
                        <div class="col-12 md:col-4">
                            <button
                                *ngIf="!progressoRequisicao; else exibirBotaoFalso"
                                type="button"
                                pButton
                                icon="pi pi-check"
                                label="Salvar"
                                (click)="salvar()"
                                class="p-button-outlined p-button-success md:w-9rem"
                                [disabled]="!f.valid"
                            ></button>
                            <ng-template #exibirBotaoFalso>
                                <button
                                    type="submit"
                                    pButton
                                    icon="pi pi-spin pi-spinner"
                                    label="Salvar"
                                    class="p-button-outlined p-button-success md:w-9rem"
                                    disabled
                                ></button>
                            </ng-template>
                        </div>
                        <div class="col-12 md:col-4 flex justify-content-end">
                            <button
                                type="button"
                                pButton
                                icon="pi pi-arrow-left"
                                label="Voltar"
                                class="p-button-outlined md:w-9rem"
                                routerLink="/apps/profissional"
                            ></button>
                        </div>
                    </div>
                </div>
            </form>
            <p-dialog
                header="Cadastrar Usuário"
                [(visible)]="mostrarModalUsuario"
                [modal]="true"
                [style]="{ width: '50vw' }"
                [draggable]="false"
                [resizable]="false"
                [closable]="false"
            >
                <form #formUsuario="ngForm" name="formuUsuario">
                    <div class="formgroup">
                        <div class="p-fluid p-formgrid grid">
                            <div *ngIf="messagemVisivelDialog" class="field col-12 md:col-12">
                                <p-messages
                                    [(value)]="messagesDialog"
                                    [enableService]="false"
                                    [closable]="true"
                                ></p-messages>
                            </div>
                            <div class="field col-12 md:col-3">
                                <label htmlFor="cpfUsuario">CPF</label>
                                <p-inputMask
                                    mask="999.999.999-99"
                                    [unmask]="true"
                                    type="text"
                                    placeholder="000.000.000-00"
                                    name="cpfUsuario"
                                    ngModel
                                    #cpfUsuario="ngModel"
                                    [(ngModel)]="cpfInformado"
                                    [readonly]="true"
                                ></p-inputMask>
                            </div>
                            <div class="field col-12 md:col-9">
                                <label htmlFor="nomeUsuario">Nome</label>
                                <input
                                    oninput="this.value = this.value.toUpperCase();"
                                    type="text"
                                    pInputText
                                    name="nomeUsuario"
                                    [(ngModel)]="usuario.nome"
                                    required
                                />
                            </div>
                            <div class="field col-12 md:col-3">
                                <label htmlFor="apelido">Apelido</label>
                                <input
                                    oninput="this.value = this.value.toUpperCase();"
                                    type="text"
                                    pInputText
                                    name="apelido"
                                    [(ngModel)]="usuario.apelido"
                                />
                            </div>
                            <div class="field col-12 md:col-6">
                                <label htmlFor="emailUsuario">E-mail</label>
                                <input
                                    pInputText
                                    type="email"
                                    placeholder="seuemail@mail.com"
                                    name="emailUsuario"
                                    ngModel
                                    email="true"
                                    #emailUsuario="ngModel"
                                    [(ngModel)]="usuario.email"
                                    (input)="verificarEmailUsuario(emailUsuario.hasError('email'))"
                                    required
                                />
                                <div *ngIf="emailUsuario.hasError('email')" class="alerta">
                                    <small>Digite um e-mail válido</small>
                                </div>
                                <div *ngIf="!emailValido && usuario.email" class="alerta">
                                    <small>Email já está em uso</small>
                                </div>
                            </div>
                            <div class="field col-12 md:col-3">
                                <label htmlFor="fonePessoal">Fone Pessoal</label>
                                <p-inputMask
                                    mask="(99) 99999-9999"
                                    [unmask]="true"
                                    type="text"
                                    placeholder="(99) 99999-9999"
                                    name="fonePessoal"
                                    ngModel
                                    #fonePessoal="ngModel"
                                    [(ngModel)]="usuario.whatsapp"
                                    [required]="true"
                                ></p-inputMask>
                            </div>
                        </div>
                    </div>
                </form>

                <div class="p-fluid p-formgrid grid justify-content-between">
                    <div class="field col-12 md:col-3" *ngIf="!progressoReqUsuario">
                        <button
                            type="button"
                            pButton
                            icon="pi pi-check"
                            label="Cadastrar"
                            class="p-button-success"
                            (click)="cadastrarUsuario()"
                            [disabled]="!formUsuario.valid || !emailValido"
                        ></button>
                    </div>
                    <div class="field col-12 md:col-3" *ngIf="progressoReqUsuario">
                        <button
                            type="submit"
                            pButton
                            icon="pi pi-spin pi-spinner"
                            label="Cadastrando..."
                            class="p-button-success mt-5"
                            [disabled]="true"
                        ></button>
                    </div>
                    <div class="field col-12 md:col-3">
                        <button
                            type="button"
                            pButton
                            icon="pi pi-times"
                            label="Cancelar"
                            class="p-button-primary"
                            (click)="fecharModalUsuario()"
                        ></button>
                    </div>
                </div>
            </p-dialog>
            <p-dialog
                header="Cadastrar Contrato"
                [(visible)]="mostrarModalContrato"
                [modal]="true"
                [style]="{ width: '60vw' }"
                [draggable]="false"
                [resizable]="false"
                [closable]="true"
                (onHide)="aoFecharDialog()"
            >
                <div class="formgroup">
                    <div class="p-fluid p-formgrid grid">
                        <div class="field col-12 md:col-12">
                            <p-messages
                                *ngIf="messagemVisivelDialog"
                                [(value)]="messagesDialog"
                                [enableService]="false"
                                [closable]="true"
                            ></p-messages>
                        </div>
                        <div class="field col-12 md:col-7">
                            <label htmlFor="razaoSocial">Razão Social</label>
                            <input
                                oninput="this.value = this.value.toUpperCase();"
                                type="text"
                                pInputText
                                name="razaoSocial"
                                ngModel
                                #razaoSocial="ngModel"
                                required
                                [(ngModel)]="contrato.razaoSocial"
                            />
                            <div
                                *ngIf="razaoSocial.hasError('required') && razaoSocial.touched"
                                class="alerta"
                            >
                                <small>Campo obrigatório</small>
                            </div>
                        </div>

                        <div class="field col-12 md:col-5">
                            <label htmlFor="cnpj">CNPJ</label>
                            <p-inputMask
                                mask="99.999.999/9999-99"
                                [unmask]="true"
                                type="text"
                                placeholder="000.000.000-00"
                                name="cnpj"
                                ngModel
                                #cnpj="ngModel"
                                [(ngModel)]="contrato.cnpj"
                            ></p-inputMask>
                        </div>
                        <div class="field col-12 md:col-4">
                            <label htmlFor="cpfTitular">CPF do Titular</label>
                            <p-inputMask
                                mask="999.999.999-99"
                                [unmask]="true"
                                type="text"
                                placeholder="000.000.000-00"
                                name="cpfTitular"
                                ngModel
                                #cpfTitular="ngModel"
                                [(ngModel)]="contrato.cpfTitular"
                                [readonly]="true"
                            ></p-inputMask>
                        </div>
                    </div>
                    <div class="container card col-12 mb-5">
                        <h5>Rateio</h5>
                        <div class="components p-fluid p-formgrid grid">
                            <div class="field col-12 md:col-3">
                                <label htmlFor="grupo">Grupo</label>
                                <p-dropdown
                                    [options]="listaGrupos"
                                    optionLabel="descricao"
                                    [filter]="true"
                                    emptyFilterMessage="Nenhum registro"
                                    placeholder="Selecione"
                                    name="grupo"
                                    ngModel
                                    #uf="ngModel"
                                    [(ngModel)]="grupoSelecionado"
                                ></p-dropdown>
                            </div>

                            <div class="field col-12 md:col-3">
                                <button
                                    pButton
                                    pRipple
                                    label="Adicionar"
                                    class="p-button-success mt-5"
                                    icon="pi pi-check"
                                    style="box-shadow: none"
                                    type="button"
                                    (click)="adicionarRateio()"
                                    [disabled]="!grupoSelecionado"
                                ></button>
                            </div>
                        </div>

                        <p-table
                            #dt1
                            [value]="listaRateios"
                            dataKey="id"
                            [rows]="10"
                            [rowHover]="true"
                            styleClass="p-datatable-gridlines"
                            [paginator]="false"
                            responsiveLayout="scroll"
                            styleClass=" p-datatable-sm"
                        >
                            <ng-template pTemplate="header">
                                <tr>
                                    <th>
                                        <div>Subgrupo</div>
                                    </th>
                                    <th>
                                        <div>Percentual</div>
                                    </th>

                                    <th>
                                        <div>Excluir</div>
                                    </th>
                                </tr>
                            </ng-template>
                            <ng-template pTemplate="body" let-rateio let-i="rowIndex">
                                <tr>
                                    <td>
                                        <input
                                            class="p-inputtext"
                                            type="text"
                                            pInputText
                                            name="prazo{{ i }}"
                                            [(ngModel)]="rateio.subgrupo.descricao"
                                            [readOnly]="true"
                                        />
                                    </td>
                                    <td>
                                        <p-inputNumber
                                            suffix="%"
                                            name="percentual{{ i }}"
                                            [max]="100"
                                            [minFractionDigits]="2"
                                            [maxFractionDigits]="2"
                                            [(ngModel)]="rateio.percentualRateio"
                                        ></p-inputNumber>
                                    </td>

                                    <td>
                                        <button
                                            pButton
                                            pRipple
                                            pTooltip="Excluir"
                                            type="button"
                                            icon="pi pi-trash"
                                            class="p-button-danger"
                                            (click)="excluirRateio(rateio)"
                                        ></button>
                                    </td>
                                </tr>
                            </ng-template>
                        </p-table>
                    </div>
                </div>
                <div class="p-fluid p-formgrid grid justify-content-between">
                    <div class="field col-12 md:col-3">
                        <button
                            type="button"
                            pButton
                            [icon]="
                                loadingCadastroContrato ? 'pi pi-spin pi-spinner' : 'pi pi-check'
                            "
                            label="Cadastrar"
                            class="p-button-success"
                            (click)="cadastrarContrato()"
                        ></button>
                    </div>
                    <div class="field col-12 md:col-3">
                        <button
                            type="button"
                            pButton
                            icon="pi pi-times"
                            label="Cancelar"
                            class="p-button-primary"
                            (click)="aoFecharDialog()"
                        ></button>
                    </div>
                </div>
            </p-dialog>
            <p-confirmDialog [style]="{ width: '50vw' }"></p-confirmDialog>
        </div>
    </div>
</div>
